import { TaxonHierarchyBaseResource, TaxonHierarchyParentResource } from '../../@api/Sylius';
import { Taxon, TaxonWithParents } from './Taxon';

export const transformToTaxon = (resource: TaxonHierarchyParentResource): Taxon => ({
    id: resource.code,
    code: resource.code,
    slug: resource.slug || '',
    name: resource.name || '',
});

const transformToTaxonParent = (resource: TaxonHierarchyParentResource): Taxon[] => {
    const taxon = transformToTaxon(resource);

    const parent = resource.parent
        ? transformToTaxonParent(resource.parent)
        : [];

    return [taxon, parent].flat();
};

export const transformToTaxonWithParents = (resource: TaxonHierarchyBaseResource): TaxonWithParents => {
    const parentArray = resource.parent
        ? transformToTaxonParent(resource.parent)
        : [];

    const parents = parentArray.reverse();

    return {
        id: resource.code,
        code: resource.code,
        slug: resource.slug || '',
        name: resource.name || '',
        parents,
    };
};
